
export const categoriesData = [
    { label: "Women's Cut & Trims", value: "Women's Cut & Trims", key: 0 },
    { label: 'Hairs Foils', value: 'Hairs Foils', key: 1 },
    { label: 'Hair Color', value: 'Hair Color', key: 2 },
    { label: 'Hair Highlights', value: 'Hair Highlights', key: 3 },
    { label: 'Hair Tint & Toner', value: 'Hair Tint & Toner', key: 4 },
    { label: 'Hair Blow Wave', value: 'Hair Blow Wave', key: 5 },
    { label: 'Hair Straightening', value: 'Hair Straightening', key: 6 },
    { label: 'Shampoo', value: 'Shampoo', key: 7 },
    { label: 'Hair Perm', value: 'Hair Perm', key: 8 },
    { label: 'Hair Extensions', value: 'Hair Extensions', key: 9 },
    { label: 'Keratin Smoothening', value: 'Keratin Smoothening', key: 10 },
    { label: "Men's Cut", value: "Men's Cut", key: 11 },
    { label: "Men's Shave", value: "Men's Shave", key: 12 },
    { label: "Men's Beard", value: "Men's Beard", key: 13 },
    { label: 'Children Hair Cut', value: 'Children Hair Cut', key: 14 },
    { label: 'Waxing', value: 'Waxing', key: 15 },
    { label: 'Threading', value: "Women's Cut & Trims", key: 16 },
    { label: 'Brazillian Wax', value: 'Brazillian Wax', key: 17 },
    {
        label: 'Eyebrow/Eyelash Tinting',
        value: 'Eyebrow/Eyelash Tinting',
        key: 18,
    },
    { label: 'Tanning', value: 'Tanning', key: 19 },
    { label: 'Facials', value: 'Facials', key: 20 },
    { label: 'Piercing', value: 'Piercing', key: 21 },
    { label: 'Manicure', value: 'Manicure', key: 22 },
    { label: 'Pedicure', value: 'Pedicure', key: 23 },
    { label: 'Massage', value: 'Massage', key: 24 },
    { label: 'Make-up', value: 'Make-up', key: 25 },
    { label: 'Coffee Sachets', value: 'Coffee Sachets', key: 26 },
    { label: 'Tea Bags', value: 'Tea Bags', key: 27 },
    { label: 'Sugar Sachets', value: 'Sugar Sachets', key: 28 },
    { label: 'Milk Tubs', value: 'Milk Tubs', key: 29 },
    { label: 'Toilet Paper', value: 'Toilet Paper', key: 30 },
    { label: 'Shampoo', value: 'Shampoo', key: 31 },
    { label: 'Conditioner', value: 'Conditioner', key: 32 },
    { label: 'Body Wash', value: 'Body Wash', key: 33 },
    { label: 'Hand Wash', value: 'Hand Wash', key: 34 },
    { label: 'Toothpaste', value: 'Toothpaste', key: 35 },
    { label: 'Toothbrush', value: 'Toothbrush', key: 36 },
    { label: 'Shaving Kit', value: 'Shaving Kit', key: 37 },
    { label: 'Room Cleaning', value: 'Room Cleaning', key: 38 },
    { label: 'Towels', value: 'Towels', key: 39 },
    { label: 'Barista Coffee', value: 'Barista Coffee', key: 40 },
    { label: 'Smoothies', value: 'Smoothies', key: 41 },
    { label: 'Bottled Water', value: 'Bottled Water', key: 42 },
    { label: 'Soft Drinks', value: 'Soft Drinks', key: 43 },
    { label: 'Physiotherapy', value: 'Physiotherapy', key: 44 },
    { label: 'Rehabilitation', value: 'Rehabilitation', key: 45 },
    { label: 'Wellbeing', value: 'Wellbeing', key: 46 },
    { label: 'Acupuncture', value: 'Acupuncture', key: 47 },
    { label: 'Pelvic Health', value: 'Pelvic Health', key: 48 },
    { label: 'Psychology', value: 'Psychology', key: 49 },
    { label: 'Concussion', value: 'Concussion', key: 50 },
    {
        label: 'Occupational Assessment',
        value: 'Occupational Assessment',
        key: 51,
    },
    { label: 'Nutrition', value: 'Nutrition', key: 52 },
    {
        label: 'Speech & Language Therapy',
        value: 'Speech & Language Therapy',
        key: 53,
    },
    { label: 'Workshops', value: 'Workshops', key: 54 },
    { label: 'Sports', value: 'Sports', key: 55 },
    { label: 'ACC & WINZ Services', value: 'ACC & WINZ Services', key: 56 },
    { label: 'Exercise & Training', value: 'Exercise & Training', key: 57 },
    { label: 'Dental Exam & X-Rays', value: 'Dental Exam & X-Rays', key: 58 },
    {
        label: 'Dental Crowns & Bridges',
        value: 'Dental Crowns & Bridges',
        key: 59,
    },
    { label: 'Braces & Invisalign', value: 'Braces & Invisalign', key: 60 },
    {
        label: 'Dental Crowns & Bridges',
        value: 'Dental Crowns & Bridges',
        key: 61,
    },
    { label: 'Dentures', value: 'Dentures', key: 62 },
    { label: 'Teeth Extraction', value: 'Teeth Extraction', key: 63 },
    { label: 'Mouth Guards', value: 'Mouth Guards', key: 64 },
    { label: 'Dentofacial', value: 'Dentofacial', key: 65 },
    { label: 'Dental Implants', value: 'Dental Implants', key: 66 },
    { label: 'Dental Hygiene', value: 'Dental Hygiene', key: 67 },
    { label: 'Root Canal', value: 'Root Canal', key: 68 },
    { label: 'Tooth Whitening', value: 'Tooth Whitening', key: 69 },
    { label: 'Kids Dental', value: 'Kids Dental', key: 70 },

    { label: 'Accommodation', value: 'Accommodation', key: 71 },
    { label: 'Tours & Attractions', value: 'Tours & Attractions', key: 72 },
    { label: 'Outdoor Activities', value: 'Outdoor Activities', key: 73 },
    { label: 'Experiences', value: 'Experiences', key: 74 },
    { label: 'Sports', value: 'Sports', key: 75 },
    { label: 'Health & Wellness', value: 'Health & Wellness', key: 76 },
    { label: 'Food & Drinks', value: 'Food & Drinks', key: 77 },
    { label: 'Getaways', value: 'Getaways', key: 78 },
    { label: 'Arts & Entertainment', value: 'Arts & Entertainment', key: 79 },
];
export const AccommodationCategoriesData = [
    { label: 'Accommodation', value: 'Accommodation', key: 0 },
    { label: 'Tours & Attractions', value: 'Tours & Attractions', key: 1 },
    { label: 'Outdoor Activities', value: 'Outdoor Activities', key: 2 },
    { label: 'Experiences', value: 'Experiences', key: 3 },
    { label: 'Sports', value: 'Sports', key: 4 },
    { label: 'Health & Wellness', value: 'Health & Wellness', key: 5 },
    { label: 'Food & Drinks', value: 'Food & Drinks', key: 6 },
    { label: 'Getaways', value: 'Getaways', key: 7 },
    { label: 'Arts & Entertainment', value: 'Arts & Entertainment', key: 8 },
];
export const salonCategoriesData = [
    { label: "Women's Cut & Trims", value: "Women's Cut & Trims", key: 0 },
    { label: 'Hairs Foils', value: 'Hairs Foils', key: 1 },
    { label: 'Hair Color', value: 'Hair Color', key: 2 },
    { label: 'Hair Highlights', value: 'Hair Highlights', key: 3 },
    { label: 'Hair Tint & Toner', value: 'Hair Tint & Toner', key: 4 },
    { label: 'Hair Blow Wave', value: 'Hair Blow Wave', key: 5 },
    { label: 'Hair Straightening', value: 'Hair Straightening', key: 6 },
    { label: 'Shampoo', value: 'Shampoo', key: 7 },
    { label: 'Hair Perm', value: 'Hair Perm', key: 8 },
    { label: 'Hair Extensions', value: 'Hair Extensions', key: 9 },
    { label: 'Keratin Smoothening', value: 'Keratin Smoothening', key: 10 },
    { label: "Men's Cut", value: "Men's Cut", key: 11 },
    { label: "Men's Shave", value: "Men's Shave", key: 12 },
    { label: "Men's Beard", value: "Men's Beard", key: 13 },
    { label: 'Children Hair Cut', value: 'Children Hair Cut', key: 14 },
    { label: 'Waxing', value: 'Waxing', key: 15 },
    { label: 'Threading', value: "Women's Cut & Trims", key: 16 },
    { label: 'Brazillian Wax', value: 'Brazillian Wax', key: 17 },
    {
        label: 'Eyebrow/Eyelash Tinting',
        value: 'Eyebrow/Eyelash Tinting',
        key: 18,
    },
    { label: 'Tanning', value: 'Tanning', key: 19 },
    { label: 'Facials', value: 'Facials', key: 20 },
    { label: 'Piercing', value: 'Piercing', key: 21 },
    { label: 'Manicure', value: 'Manicure', key: 22 },
    { label: 'Pedicure', value: 'Pedicure', key: 23 },
    { label: 'Massage', value: 'Massage', key: 24 },
    { label: 'Make-up', value: 'Make-up', key: 25 },
];
export const GuestServicesCategoriesData = [
    { label: 'Coffee Sachets', value: 'Coffee Sachets', key: 0 },
    { label: 'Tea Bags', value: 'Tea Bags', key: 1 },
    { label: 'Sugar Sachets', value: 'Sugar Sachets', key: 2 },
    { label: 'Milk Tubs', value: 'Milk Tubs', key: 3 },
    { label: 'Toilet Paper', value: 'Toilet Paper', key: 4 },
    { label: 'Shampoo', value: 'Shampoo', key: 5 },
    { label: 'Conditioner', value: 'Conditioner', key: 6 },
    { label: 'Body Wash', value: 'Body Wash', key: 7 },
    { label: 'Hand Wash', value: 'Hand Wash', key: 8 },
    { label: 'Toothpaste', value: 'Toothpaste', key: 9 },
    { label: 'Toothbrush', value: 'Toothbrush', key: 10 },
    { label: 'Shaving Kit', value: 'Shaving Kit', key: 11 },
    { label: 'Room Cleaning', value: 'Room Cleaning', key: 12 },
    { label: 'Towels', value: 'Towels', key: 13 },
    { label: 'Barista Coffee', value: 'Barista Coffee', key: 14 },
    { label: 'Smoothies', value: 'Smoothies', key: 15 },
    { label: 'Bottled Water', value: 'Bottled Water', key: 16 },
    { label: 'Soft Drinks', value: 'Soft Drinks', key: 17 },
];
export const DoctorServicesCategoriesData = [
    { label: 'Physiotherapy', value: 'Physiotherapy', key: 0 },
    { label: 'Rehabilitation', value: 'Rehabilitation', key: 1 },
    { label: 'Wellbeing', value: 'Wellbeing', key: 2 },
    { label: 'Acupuncture', value: 'Acupuncture', key: 3 },
    { label: 'Pelvic Health', value: 'Pelvic Health', key: 4 },
    { label: 'Psychology', value: 'Psychology', key: 5 },
    { label: 'Concussion', value: 'Concussion', key: 6 },
    {
        label: 'Occupational Assessment',
        value: 'Occupational Assessment',
        key: 7,
    },
    { label: 'Nutrition', value: 'Nutrition', key: 8 },
    {
        label: 'Speech & Language Therapy',
        value: 'Speech & Language Therapy',
        key: 9,
    },
    { label: 'Workshops', value: 'Workshops', key: 10 },
    { label: 'Sports', value: 'Sports', key: 11 },
    { label: 'ACC & WINZ Services', value: 'ACC & WINZ Services', key: 12 },
    { label: 'Exercise & Training', value: 'Exercise & Training', key: 13 },
    { label: 'Dental Exam & X-Rays', value: 'Dental Exam & X-Rays', key: 14 },
    {
        label: 'Dental Crowns & Bridges',
        value: 'Dental Crowns & Bridges',
        key: 15,
    },
    { label: 'Braces & Invisalign', value: 'Braces & Invisalign', key: 16 },
    {
        label: 'Dental Crowns & Bridges',
        value: 'Dental Crowns & Bridges',
        key: 17,
    },
    { label: 'Dentures', value: 'Dentures', key: 18 },
    { label: 'Teeth Extraction', value: 'Teeth Extraction', key: 19 },
    { label: 'Mouth Guards', value: 'Mouth Guards', key: 20 },
    { label: 'Dentofacial', value: 'Dentofacial', key: 21 },
    { label: 'Dental Implants', value: 'Dental Implants', key: 22 },
    { label: 'Dental Hygiene', value: 'Dental Hygiene', key: 23 },
    { label: 'Root Canal', value: 'Root Canal', key: 24 },
    { label: 'Tooth Whitening', value: 'Tooth Whitening', key: 25 },
    { label: 'Kids Dental', value: 'Kids Dental', key: 26 },
];